<div class="card">
    <div class="card-body p-2">
        <div mat-dialog-title class="heading">Redaction Details</div>
        <div>
            <!-- <mat-divider></mat-divider> -->

            <form #initiateForm="ngForm">
                <!-- <div style="text-align: center;">Please provide the updated values</div> -->
                <div class="input-group-sm mt-2 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Redaction Status</span>
                    </div>
                    <label class="form-control border">{{redactionStatus ? redactionStatus['Redaction Status'] : 'Not Initiated'}}</label>
                </div>
                <div class="input-group-sm mt-2 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Redaction Category</span>
                    </div>
                    <label class="form-control border">{{redactionStatus && redactionStatus['Redaction Status'] === "Completed" ? documentDetails['categoryName'] + ' Redacted' : 'N/A'}}</label>
                </div>
                <div>
                    <button mat-raised-button class="closeButton float-right m-2" (click)="onClose()">Close</button>&nbsp;
                    <button mat-raised-button class="actionButton float-right m-2" (click)="onRedact()" type="submit">Redact</button>
                </div>
            </form>
        </div>

        <!-- <div *ngIf="uploadMessage">
            <div>File Upload has been completed successfully.</div>
            <button class="closeButton float-right m-2" mat-raised-button (click)="onClose()">Close</button>
        </div> -->
    </div>
</div>